// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/analyze_experiment_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentResults } from "./experiment_results_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_results } from "./experiment_results_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/analyze_experiment_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_response: GenFile = /*@__PURE__*/
  fileDesc("CklxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYW5hbHl6ZV9leHBlcmltZW50X3Jlc3BvbnNlLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiiwEKGUFuYWx5emVFeHBlcmltZW50UmVzcG9uc2USWQoQYW5hbHlzaXNfcmVzdWx0cxgBIAEoCzI6LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5FeHBlcmltZW50UmVzdWx0c0gAiAEBQhMKEV9hbmFseXNpc19yZXN1bHRzYgZwcm90bzM", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_results]);

/**
 * Rpc response containing analysis results
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentResponse
 */
export type AnalyzeExperimentResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentResponse"> & {
  /**
   * Outputs of analysis for the experiment
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentResults analysis_results = 1;
   */
  analysisResults?: ExperimentResults;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentResponse.
 * Use `create(AnalyzeExperimentResponseSchema)` to create a new message.
 */
export const AnalyzeExperimentResponseSchema: GenMessage<AnalyzeExperimentResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_response, 0);

